import {
    Avatar,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Stack,
    Typography
} from '@mui/material';
import React from 'react';
import { OpenModalHookType } from '@hooks/useOpenModal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { UserType } from '@api/Users/User';
import noAvatar from '@assets/img/noAvatar.png';
import { format } from 'date-fns';
interface ModalUserInfoProps {
    modalUserInfo: OpenModalHookType;
    user: UserType;
    onEditUser: (user: UserType) => void;
    onToggleStatus: (userId: string) => void;
    /** Sin él no hay botón: borrar es del admin general (el de sucursal desactiva). */
    onDeleteUser?: () => void;
}

export const ModalUserInfo: React.FunctionComponent<ModalUserInfoProps> = (props) => {
    const { modalUserInfo, user, onEditUser, onToggleStatus, onDeleteUser } = props;

    const handleClose = () => {
        modalUserInfo.toggle();
    };

    return (
        <Dialog
            PaperProps={{
                style: { borderRadius: 15, padding: 4 }
            }}
            open={modalUserInfo.modalOpen}
            onClose={handleClose}
            aria-labelledby="modal-save-user-title"
            aria-describedby="modal-save-user-description"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="modal-save-user-title">
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight={600}>
                        Información del usuario
                    </Typography>
                    <Stack direction="row" alignItems="center">
                        <Button color="primary" variant="text" onClick={() => onEditUser(user)}>
                            Editar
                        </Button>
                        <Box>
                            <IconButton color="secondary" onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Stack>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar
                            sx={{ width: 70, height: 70 }}
                            src={user.profile.photo ? user.profile.photo : noAvatar}
                        />
                        <Stack>
                            <Typography variant="body1" fontWeight={600}>
                                {user.profile.name}
                            </Typography>
                            <Typography variant="body1">{user.profile.profile}</Typography>
                            <Typography variant="body1">{user.profile.phone}</Typography>
                        </Stack>
                    </Stack>
                    <Stack>
                        <Typography variant="body1" color="gray">
                            Correo
                        </Typography>
                        <Typography variant="body1">{user.email}</Typography>
                    </Stack>
                    <Stack>
                        <Typography variant="body1" color="gray">
                            Dirección
                        </Typography>
                        <Typography variant="body1">{user.profile.address}</Typography>
                    </Stack>
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Stack direction="row" flex={1} justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" color="gray">
                        {`Creado el: ${format(new Date(user.createdAt.toDate()), 'dd-MM-yy pp')}`}
                    </Typography>
                    <Stack direction="row">
                        <Button
                            color={user.profile.status ? 'warning' : 'success'}
                            variant="text"
                            onClick={() => onToggleStatus(user.uid)}
                        >
                            {user.profile.status ? 'Inactivar' : 'Activar'}
                        </Button>
                        {onDeleteUser && (
                            <Button color="error" variant="text" onClick={onDeleteUser}>
                                Eliminar
                            </Button>
                        )}
                    </Stack>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};
